import React from 'react';
import { Outlet } from 'react-router-dom';
import MailMarketingSidebar from './MailMarketingSidebar';

const MailMarketingLayout = () => {
  return (
    <div className="d-flex flex-column flex-md-row min-vh-100 bg-dark-main">
      <MailMarketingSidebar />
      <div className="flex-grow-1 d-flex flex-column overflow-hidden h-100">
        <div className="flex-grow-1 overflow-y-auto w-100" style={{ height: '100vh' }}>
          <Outlet />
        </div>
      </div>
      
      <style jsx="true">{`
        .bg-dark-main {
          background-color: #020617; /* Very dark slate, matching premium SaaS themes */
        }
      `}</style>
    </div>
  );
};

export default MailMarketingLayout;
